import { useState } from "react";
import "./ClientRegistration.style.css";
interface IAssociatedEmail {
  email: string;
}

interface IClientForm {
  logo: File | null;
  name: string;
  fantasyName: string;
  cnpj: string;
  email: string;
  associatedEmails: IAssociatedEmail[];
}

export const ClientRegistration: React.FC = () => {
  const [formData, setFormData] = useState<IClientForm>({
    logo: null,
    name: "",
    fantasyName: "",
    cnpj: "",
    email: "",
    associatedEmails: [],
  });
  const [newEmail, setNewEmail] = useState("");
  const [previewLogo, setPreviewLogo] = useState<string>("");

  const handleLogoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFormData({ ...formData, logo: file });
      setPreviewLogo(URL.createObjectURL(file));
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddEmail = () => {
    if (
      newEmail &&
      !formData.associatedEmails.some((e: any) => e.email === newEmail)
    ) {
      setFormData({
        ...formData,
        associatedEmails: [...formData.associatedEmails, { email: newEmail }],
      });
      setNewEmail("");
    }
  };

  const handleRemoveEmail = (emailToRemove: string) => {
    setFormData({
      ...formData,
      associatedEmails: formData.associatedEmails.filter(
        (e: any) => e.email !== emailToRemove
      ),
    });
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    console.log("Dados do formulário:", formData);
    // Aqui você implementaria a lógica de envio para o backend
  };

  const handleClear = () => {
    setFormData({
      logo: null,
      name: "",
      fantasyName: "",
      cnpj: "",
      email: "",
      associatedEmails: [],
    });
    setPreviewLogo("");
    setNewEmail("");
  };

  return (
    <div className="container">
      <form onSubmit={handleSubmit}>
        <div className="form-section">
          <h2 className="form-title">Cadastro de Cliente</h2>

          <div className="form-group">
            <label className="form-label">Logo:</label>
            <div
              className="logo-upload"
              onClick={() => document.getElementById("logo-input")?.click()}
            >
              {previewLogo ? (
                <img src={previewLogo} alt="Logo preview" />
              ) : (
                <span>Add Logo</span>
              )}
            </div>
            <input
              id="logo-input"
              type="file"
              accept="image/*"
              onChange={handleLogoChange}
              style={{ display: "none" }}
            />
          </div>

          <div className="form-group">
            <label className="form-label required">Nome:</label>
            <input
              className="form-input"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>

        <div className="form-section">
          <h3 className="form-title">E-mails Associados</h3>
          <p className="form-subtitle">
            Um link de acesso será enviado para os e-mails realizarem o cadastro
          </p>

          <div className="form-group">
            <input
              className="form-input"
              type="email"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              placeholder="Adicionar novo e-mail"
            />
            <button
              type="button"
              className="button button-primary"
              onClick={handleAddEmail}
            >
              Adicionar
            </button>
          </div>

          <div className="email-tags">
            {formData.associatedEmails.map((item: any, index: any) => (
              <div key={index} className="email-tag">
                {item.email}
                <button
                  type="button"
                  className="email-tag-remove"
                  onClick={() => handleRemoveEmail(item.email)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>

          <div className="buttons-container">
            <button
              type="button"
              className="button button-secondary"
              onClick={handleClear}
            >
              Limpar
            </button>
            <button type="submit" className="button button-primary">
              Concluir
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
